import { TemplateResult } from 'lit';

export type Row = RowConfig | RowContent;

export function isRowConfig(row: Row): row is RowConfig {
  return typeof row === 'object' && 'cells' in row;
}

export interface RowConfig {
  data: unknown;
  cells: Array<CellContent | CellConfig>;
}

export type RowContent = Array<Cell>;

export type Cell = CellConfig | CellContent;

export function isCellConfig(cell: Cell): cell is CellConfig {
  return typeof cell === 'object' && 'html' in cell;
}

export interface CellConfig {
  data: unknown;
  disableClick?: boolean;
  html: CellContent;
}

export type CellContent = string | TemplateResult;
